import { useMutation } from '@tanstack/react-query'

import { publicationApi, type TMarkPublicationAsReadProps } from '../api/publicationApi'

export const usePublicationMarkAsReadMutation = ({
  publicationId,
}: Pick<TMarkPublicationAsReadProps, 'publicationId'>) =>
  useMutation({
    mutationFn: (props: Pick<TMarkPublicationAsReadProps, 'userId' | 'source'>) =>
      publicationApi.markPublicationAsRead({ ...props, publicationId }),
  })
